'use client';

import { useMemo } from 'react';
import { Id } from '@/convex/_generated/dataModel';
import { SimpleSelect } from '@ui/components/select';

export interface GardenOption {
  _id: Id<'gardens'> | string;
  name: string;
  plants: unknown[];
  rows?: number;
  columns?: number;
}

interface GardenSelectProps {
  gardens: GardenOption[];
  selectedGardenId: string | null;
  onGardenChange: (gardenId: string | null) => void;
  label?: string;
  placeholder?: string;
  showPlantCount?: boolean;
  disabled?: boolean;
  width?: string | number;
}

export function GardenSelect({
  gardens,
  selectedGardenId,
  onGardenChange,
  label = 'Selected Garden',
  placeholder = 'Select a garden',
  showPlantCount = true,
  disabled = false,
  width = '100%',
}: GardenSelectProps) {
  const options = useMemo(
    () =>
      gardens.map((garden) => ({
        value: garden._id,
        label: showPlantCount ? `${garden.name} (${garden.plants.length} plants)` : garden.name,
      })),
    [gardens, showPlantCount]
  );

  return (
    <div style={{ width }}>
      <SimpleSelect
        id="garden-select"
        value={selectedGardenId ?? ''}
        onValueChange={(value) => onGardenChange(value || null)}
        options={options}
        placeholder={placeholder}
        disabled={disabled}
        label={label}
      />
    </div>
  );
}
